import _ from "lodash"

export const getGeneralData = state => _.get(state,['general','data','data'],null)

//general
export const getGeneralDateDailyBusinessValue  = general => _.get(general,['date','daily-business','value'],'')
export const getGeneralDateMarginStatementValue  = general => _.get(general,['date','margin-statement','value'],'')
export const getGeneralDateOutstandingSummaryValue  = general => _.get(general,['date','outstanding-summary','value'],'')
export const getGeneralOptionsContractStatus  = general => _.get(general,['options','contractStatus'],[])
export const getGeneralOptionsPaymentStatus  = general => _.get(general,['options','paymentStatus'],[])
